module.exports = __webpack_public_path__ + "img/link-02.dd769418.svg";